<template>
  <div id="timer-block" class="text-center">
    <popup-message :visible="showEndDayMessage" :close="null">
      <info-block label="<p class='mb-3'>Хорошего вечера и спасибо за работу!</p><div class='text-secondary'>В 00:00 таймер начнёт отсчёт времени сначала, но всё отработанное вами время останется сохранённым.</div>" icon="bi-check-circle-fill" css-classes="text-success"></info-block>
      <button type="button" @click="showEndDayMessage = false;" class="btn btn-min-width btn-lg btn-primary rounded-pill">ОК</button>
    </popup-message>

    <div class="work-timer">
      <div class="text-secondary mb-1">Отработано сегодня</div>
      <div class="work-timer-value mb-3">{{ workTimeFormatted }}</div>
    </div>
    <div class="mb-3">
      <button class="btn btn-lg btn-min-width rounded-pill" :class="{'btn-primary': !isWorking, 'btn-secondary': isWorking}" @click="toggleWorkTimer">{{ btnLabel }}</button>
    </div>
    <div class="mb-3">
      <button v-if="isWorking" class="btn btn-lg btn-danger btn-min-width rounded-pill" @click="endWorkingDay">Завершить работу</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { formatTimer } from "@/helpers/format_date";

export default {
  data() {
    return {
      showEndDayMessage: false
    }
  },
  computed: {
    ...mapState({
      workTime: state => state.timer.workTime,
    }),
    ...mapGetters({
      isWorking: 'timer/isWorking'
    }),
    workTimeFormatted() {
      return formatTimer(this.workTime);
    },
    btnLabel() {
      if (this.showEndDayMessage) {
        return 'Начать работу';
      }

      return this.isWorking
          ? 'Перерыв'
          : (this.workTime ? 'Продолжить' : 'Начать работу');
    }
  },
  methods: {
    ...mapMutations({
      startWorking: 'timer/start',
      stopWorking: 'timer/stop',
    }),
    toggleWorkTimer() {
      this.isWorking ? this.stopWorking() : this.startWorking();
    },
    endWorkingDay() {
      this.stopWorking();
      this.showEndDayMessage = true;
    }
  },
  mounted() {
    this.$store.dispatch('timer/loopUpdateDB');
    this.$store.dispatch('timer/loopUpdateTimer');
  }
}
</script>

<style lang="scss" scoped>
#timer-block {
  .work-timer {
    &-value {
      font-size: 50px;
      line-height: 1.25;
    }
  }
}
</style>